<template>
  <ItemsLister v-bind="itemsListerConfig" :itemsListHelpers="subscriptionsListHelpers" />
</template>

<script lang="ts" setup>
import ItemsLister from '@/components/ListingPages/ItemsLister/ItemsLister.vue';
import itemsListerConfig from './config/itemsLister.config';
import { useSubscriptionsListHelpers } from './subscriptionsListHelpers';
const subscriptionsListHelpers = useSubscriptionsListHelpers();
</script>

<style lang="scss" scoped>
</style>